/**
 * @file tool to dynamically load data from files
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import * as DEFINITIONS from '../Utils/Constants';
import { linLoadData } from './LinuxDataLoader';
import { winLoadData } from './WindowsDataLoader';

export const loadData = (installation) => {
    switch (installation) {
        case DEFINITIONS.LINUX_11_6_09:
        case DEFINITIONS.LINUX_11_6_06:
        case DEFINITIONS.LINUX_11_6_03:
        case DEFINITIONS.LINUX_11_5_12:
        case DEFINITIONS.LINUX_11_5_09:
        case DEFINITIONS.LINUX_11_5_06:
        case DEFINITIONS.LINUX_11_5_03:
        case DEFINITIONS.LINUX_11_4_12:
            linLoadData(installation);
            break;

        case DEFINITIONS.WINDOWS_11_6_09_CUSTOM:
        case DEFINITIONS.WINDOWS_11_6_09_EXPRESS:
        case DEFINITIONS.WINDOWS_11_6_06_CUSTOM:
        case DEFINITIONS.WINDOWS_11_6_06_EXPRESS:
        case DEFINITIONS.WINDOWS_11_6_03_CUSTOM:
        case DEFINITIONS.WINDOWS_11_6_03_EXPRESS:
        case DEFINITIONS.WINDOWS_11_5_12_CUSTOM:
        case DEFINITIONS.WINDOWS_11_5_12_EXPRESS:
        case DEFINITIONS.WINDOWS_11_5_09_CUSTOM:
        case DEFINITIONS.WINDOWS_11_5_09_EXPRESS:
        case DEFINITIONS.WINDOWS_11_5_06_CUSTOM:
        case DEFINITIONS.WINDOWS_11_5_06_EXPRESS:
        case DEFINITIONS.WINDOWS_11_5_03_CUSTOM:
        case DEFINITIONS.WINDOWS_11_5_03_EXPRESS:
        case DEFINITIONS.WINDOWS_11_4_12_CUSTOM:
        case DEFINITIONS.WINDOWS_11_4_12_EXPRESS:
            winLoadData(installation);
            break;
        default:
    }
};
